import { DetailedHTMLProps, InputHTMLAttributes } from 'react'

type PropType = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>

const BaseRadioButton = (props: PropType) => {
  const { className, checked, onClick, ...restProps } = props
  return (
    <>
      <input type="radio" className="hidden" {...restProps} checked={checked} />
      <span
        className={`rounded-full inline-block flex-no-shrink w-4 h-4 flex justify-center items-center cursor-pointer ${
          checked
            ? `bg-blue-bullet text-blue-bullet `
            : 'border border-gray-400'
        } ${className || ''}`}
        onClick={onClick}
      >
        {checked && <div className="w-1 h-1 bg-white rounded-full " />}
      </span>
    </>
  )
}

export default BaseRadioButton
